import { useContext } from 'react'
import { useFlag } from '@unleash/proxy-client-react'

import { FlagContext } from '../context/OrbitFlagProvider'

import OrbitSession from './useCookies'

function useOrbitFlag(flag) {
  if (flag === '') return true
  const provider = OrbitSession.get('provider')
  switch (provider) {
    case 'UL':
      return useFlag(flag)

    case 'OB': {
      const allFlags = useContext(FlagContext)
      const flagObject = allFlags.find((flagObj) => flagObj.name === flag)
      return flagObject ? flagObject.enabled : false
    }

    default:
      break
  }
}

export default useOrbitFlag
